import React, { useEffect } from "react";
import "./PrivacyPolicy.scss";
import Navbar from "../navbar";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { changeLayoutMode } from "../../../../slices/thunks";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Footer from "../footer";

const FeedBack = () => {
  const dispatch = useDispatch();
  const selectLayoutState = (state) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );
  const { layoutModeType } = useSelector(selectLayoutProperties);

  useEffect(() => {
    if (layoutModeType) {
      window.dispatchEvent(new Event("resize"));
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType, dispatch]);
  /*
call dark/light mode
*/
  const onChangeLayoutMode = (value) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };
  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures this runs once when the component mounts

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="justify-content-center">
            <Col lg={10}>
              <Card>
                <div className="bg-warning-subtle position-relative">
                  <CardBody className="p-5">
                    <div className="text-center">
                      <h1>FeedBack</h1>
                      <p>Last Updated: November 2024</p>
                    </div>
                  </CardBody>
                  <div className="shape">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      // xmlns:svgjs="http://svgjs.com/svgjs"
                      width="1440"
                      height="60"
                      preserveAspectRatio="none"
                      viewBox="0 0 1440 60"
                    >
                      <g mask='url("#SvgjsMask1001")' fill="none">
                        <path
                          d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z"
                          style={{ fill: "var(--vz-secondary-bg)" }}
                        ></path>
                      </g>
                      <defs>
                        <mask id="SvgjsMask1001">
                          <rect width="1440" height="60" fill="#ffffff"></rect>
                        </mask>
                      </defs>
                    </svg>
                  </div>
                </div>
                <CardBody className="p-4">
                  <div>
                    <Navbar
                      onChangeLayoutMode={onChangeLayoutMode}
                      layoutModeType={layoutModeType}
                    />
                    <div className="simple-privacy-policy">
                      <section>
                        <p>
                          We take your feedback very seriously. Please send us your feedback
                          at <a>codeplayers@outlook.com</a>
                        </p>
                        <p>You can also write or call us at:</p>
                        <h3>CODEPLAYERS Business System Private Limited</h3>
                        <p>191/2, Nand Bhawan, Gandhi Ganj, Raigarh(CG) 496001, INDIA</p>
                        <p>Phone: +91 75818 75000, +91 75828 75000</p>
                        <p>
                          Email: <a href="codeplayers@outlook.com">codeplayers@outlook.com</a>
                        </p>
                      </section>
                      <footer>
                        <h2>Contact Us</h2>
                        <p>
                          Questions? Email us at{" "}
                          <a href="mailto:admin@codeplayers.in">admin@codeplayers.in</a>
                        </p>
                      </footer>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer/>
    </React.Fragment>
  );
};

export default FeedBack;
